import { useMemo } from "react";

import { BucketOfLearninRow } from "./BucketOfLearninRow";
import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import type { Enrollment } from "sj-ui-toolkit/src/api/userEnrollments";
import { getEnrolledRoleIds, questsToLearnins } from "../../../../helpers/learnins";

export const QuestBucket = ({ currentQuests = [] }: { currentQuests?: Enrollment[] }) => {
  const { quests, isLoading } = useLevelContext();

  // Order quests: enrolled first, then the rest. See sortByEnrollment for details.
  const orderedQuests = useMemo(
    () => questsToLearnins(quests, getEnrolledRoleIds(currentQuests)),
    [quests, currentQuests]
  );

  return (
    <div className="my-8">
      <BucketOfLearninRow
        key="quest-row"
        id="quest"
        name="Quests"
        variant="indigo"
        loading={isLoading}
        learnins={orderedQuests}
        pathType="Quest"
        viewAllHref="/quests"
      />
    </div>
  );
};
